module.exports = __webpack_public_path__ + "img/UserBackgroundImage.f2a7e00d.png";